import { useMemo } from 'react';
import type { Turn } from '../../types/ski-data';
import { generateTurnNarrative } from '../../utils/coach-templates';

/**
 * CoachScript - Coach narrative block for the diagnostic panel (FR-04).
 *
 * Renders the three-segment (What → Why → How) narrative generated by
 * `generateTurnNarrative`, with an ice-colored left border to anchor it as
 * the panel's primary content.
 */
interface CoachScriptProps {
  turn: Turn;
}

export default function CoachScript({ turn }: CoachScriptProps) {
  // Narrative depends only on the turn's diagnostic fields, so memoize.
  const narrative = useMemo(() => generateTurnNarrative(turn), [turn]);

  return (
    <div
      style={{
        borderLeft: '3px solid var(--color-ice)',
        paddingLeft: 'var(--space-md)',
        fontSize: 'var(--fs-lg)',
        color: 'var(--text-primary)',
        fontWeight: 'var(--fw-medium)',
        lineHeight: 1.6,
      }}
    >
      {narrative}
    </div>
  );
}
